module.exports = __webpack_public_path__ + "static/media/ipad_air.a207950f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple/ipad_air.png
// module id = 1138
// module chunks = 0